import { memo } from 'react'

const CustomButton = ({ children, ...rest }) => (
  <button {...rest}>{children}</button>
)

CustomButton.defaultProps = {
  type: 'button',
}

export default memo(CustomButton)
